<script>
import CustomInput from "@/components/Common/CustomInput.vue";

export default {
  name: "form-elements-custom-input",
  extends: CustomInput,
  props: {
    variant: {
      type: String,
      default: "form-elements",
    },
  },
};
</script>